import React from "react";

const Bar = ({ className = "" }) => (
  <div className={`bg-gray-300 rounded animate-pulse ${className}`} />
);

const ElementSkeleton = () => (
  <div className="cf-builder-skeleton w-full p-6 flex gap-4">
    <div className="flex-1 flex flex-col gap-4">
      <Bar className="h-5 w-1/3" />
      <Bar className="h-3 w-full" />
      <Bar className="h-3 w-5/6" />
      <Bar className="h-3 w-4/6" />
    </div>
    <Bar className="w-1/3 self-stretch" />
  </div>
);

const SectionSkeleton = () => (
  <div className="cf-builder-skeleton w-full p-6 flex gap-4">
    {[0, 1, 2].map((i) => (
      <Bar key={i} className="h-24 flex-1" />
    ))}
  </div>
);

const StepSkeleton = () => (
  <div className="cf-builder-skeleton w-full bg-white p-6 flex flex-col gap-4">
    {[0, 1, 2].map((i) => (
      <Bar key={i} className="h-24 w-full" />
    ))}
  </div>
);

const SKELETONS = {
  elements: ElementSkeleton,
  sections: SectionSkeleton,
  steps: StepSkeleton,
};

const BuilderSkeletonPlaceholder = (props) => {
  const Skeleton = SKELETONS[props.object_type] || ElementSkeleton;
  return <Skeleton />;
};

export default BuilderSkeletonPlaceholder;
